import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "new_collection",
  "use": "new_collection-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"new_collection\"><g fill-rule=\"evenodd\"><path d=\"M1 8h11v2h3v3h1v3H1z\" opacity=\".12\" /><path d=\"M1 15h15v1H1z\" opacity=\".12\" /><path d=\"M15 6H7.5l-2-2H1v12h15v-3h1V5h-2v1ZM0 4.007C0 3.45.451 3 .99 3H6l2 2h9v10.998C17 16.55 16.545 17 16 17H1c-.552 0-1-.45-1-1.007V4.007ZM1 7h11v1H1V7Z\" /><path d=\"M16 9h-3V8h3V5h1v3h3v1h-3v3h-1V9Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol